export class NamedResponse {
  id: number = 0;
  name: string = '';
}
